const className = 'packet';

const isAvailable = ({packet}) => Boolean(packet);

const getProps = ({packet}) => packet;

export default {className, isAvailable, getProps};
